"use client";

import { cn } from "@/lib/utils";
import { usePublicPathname } from "@/app/hooks/use-public-pathname";
import { isBrandPath } from "@/app/config/brand-registry";

export default function FooterBrandShell({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePublicPathname();
  const isSkoda = isBrandPath(pathname, "skoda");
  const isAudi = isBrandPath(pathname, "audi");

  return (
    <footer
      className={cn(
        "bg-primary border-muted/20 border-t",
        isSkoda && "bg-[#0E3A2F]",
        isAudi && "border-t-0 bg-black"
      )}
    >
      {children}
    </footer>
  );
}
